<!-- Floating AI Chat Panel -->
<div class="ai-chat-panel" [class.open]="isOpen">

    <!-- Panel Header -->
    <div class="panel-header">
        <div class="header-left">
            <i class="pi pi-comment"></i>
            <span class="header-title">AI Hilfe-Assistent</span>
            <span class="module-badge" *ngIf="currentModule">{{currentModule | uppercase}}</span>
        </div>
        <div class="header-actions">
            <button pButton
                    icon="pi pi-history"
                    class="p-button-text p-button-sm"
                    pTooltip="Verlauf"
                    (click)="onToggleHistory()">
            </button>
            <button pButton
                    icon="pi pi-plus"
                    class="p-button-text p-button-sm"
                    pTooltip="Neue Konversation"
                    (click)="onNewConversation()">
            </button>
            <button pButton
                    icon="pi pi-times"
                    class="p-button-text p-button-sm"
                    (click)="onClose()">
            </button>
        </div>
    </div>

    <!-- Conversation History View -->
    <div class="history-view" *ngIf="showHistory">
        <h3>Bisherige Konversationen</h3>
        <div class="conversation-list">
            <div *ngFor="let conv of conversations"
                 class="conversation-item"
                 (click)="onConversationClick(conv)">
                <div class="conv-info">
                    <span class="conv-title">{{conv.title || 'Unbenannt'}}</span>
                    <span class="conv-date">{{conv.lastMessageDate | date:'dd.MM.yyyy HH:mm'}}</span>
                </div>
                <button pButton
                        icon="pi pi-trash"
                        class="p-button-text p-button-sm p-button-danger"
                        (click)="onDeleteConversation(conv, $event)">
                </button>
            </div>
            <div *ngIf="conversations.length === 0" class="empty-history">
                <p>Noch keine Konversationen vorhanden.</p>
            </div>
        </div>
        <button pButton
                label="Zurück zum Chat"
                icon="pi pi-arrow-left"
                class="p-button-text p-button-sm back-button"
                (click)="onToggleHistory()">
        </button>
    </div>

    <!-- Chat View -->
    <div class="chat-view" *ngIf="!showHistory">
        <!-- Messages -->
        <div class="messages-container" #messageContainer>
            <!-- Welcome / Suggested Questions (shown when no messages) -->
            <div *ngIf="messages.length === 0" class="welcome-view">
                <div class="welcome-icon">
                    <i class="pi pi-sparkles"></i>
                </div>
                <h3>Wie kann ich helfen?</h3>
                <p>Stellen Sie eine Frage zur Dokumentation oder wählen Sie einen Vorschlag.</p>

                <div class="suggested-questions" *ngIf="suggestedQuestions.length > 0">
                    <div *ngFor="let sq of suggestedQuestions"
                         class="suggested-question"
                         (click)="onSuggestedQuestionClick(sq)">
                        <i class="pi pi-arrow-right"></i>
                        <span>{{sq.question}}</span>
                    </div>
                </div>
            </div>

            <!-- Message bubbles -->
            <div *ngFor="let msg of messages"
                 class="message"
                 [class.user-message]="msg.role === 'user'"
                 [class.assistant-message]="msg.role === 'assistant'">
                <div class="message-avatar">
                    <i [class]="msg.role === 'user' ? 'pi pi-user' : 'pi pi-sparkles'"></i>
                </div>
                <div class="message-content">
                    <div class="message-text" [innerHTML]="msg.content"></div>
                    <!-- Sources -->
                    <div *ngIf="msg.sources && msg.sources.length > 0" class="message-sources">
                        <span class="sources-label">Quellen:</span>
                        <span *ngFor="let source of msg.sources; let last = last"
                              class="source-link">
                            {{source.title}}<span *ngIf="!last">, </span>
                        </span>
                    </div>
                    <!-- Confidence -->
                    <div *ngIf="msg.confidenceScore !== undefined && msg.confidenceScore !== null" class="confidence-indicator">
                        <span class="confidence-label">Konfidenz:</span>
                        <span class="confidence-value"
                              [class.high]="msg.confidenceScore >= 0.7"
                              [class.medium]="msg.confidenceScore >= 0.4 && msg.confidenceScore < 0.7"
                              [class.low]="msg.confidenceScore < 0.4">
                            {{(msg.confidenceScore * 100) | number:'1.0-0'}}%
                        </span>
                    </div>
                </div>
            </div>

            <!-- Loading indicator -->
            <div *ngIf="isLoading" class="message assistant-message loading-message">
                <div class="message-avatar">
                    <i class="pi pi-sparkles"></i>
                </div>
                <div class="message-content">
                    <div class="typing-indicator">
                        <span></span><span></span><span></span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Input Area -->
        <div class="input-area">
            <textarea #questionInput
                      [(ngModel)]="questionText"
                      (keydown)="onKeyDown($event)"
                      placeholder="Stellen Sie eine Frage..."
                      rows="1"
                      [disabled]="isLoading || !currentModule"
                      class="chat-input">
            </textarea>
            <button pButton
                    icon="pi pi-send"
                    class="p-button-rounded send-button"
                    [disabled]="!questionText.trim() || isLoading || !currentModule"
                    (click)="onSendQuestion()">
            </button>
        </div>
    </div>
</div>
